import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leistungsstufen',
  templateUrl: './leistungsstufen.component.html',
  styleUrls: ['./leistungsstufen.component.scss']
})
export class LeistungsstufenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
